"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyboardLayout = void 0;
var _LanguageEnum = require("./LanguageEnum");
const KeyboardLayout = exports.KeyboardLayout = {
  [_LanguageEnum.Languages.EN_US]: {
    default: ['` q w e r t y u i o p {bksp}', '{tab} a s d f g h j k l ; \' {enter}', '{shift} z x c v b n m , . / {shift}', '{language} {space} {numbers} {special}'],
    shift: ['~ Q W E R T Y U I O P {bksp}', '{tab} A S D F G H J K L : " {enter}', '{shift} Z X C V B N M < > ? {shift}', '{language} {space} {numbers} {special}'],
    numbers: ['+ 1 2 3 % {bksp}', '- 4 5 6 {space} {language}', '* 7 8 9 = {abc}', '/ . 0 , {enter} {special}'],
    special: ['! @ # $ % ^ & * ( ) _ + {bksp}', '{tab} { } [ ] \\ | ~ ` {enter}', '{shift} < > , . ; : {shift}', '{language} {space} {numbers} {abc}']
  },
  [_LanguageEnum.Languages.PT_BR]: {
    default: ["` q w e r t y u i o p {bksp}", "{tab} a s d f g h j k l ç ~ ´ {enter}", "{shift} z x c v b n m , . ; / {shift}", "{language} {space} {numbers} {special}"],
    shift: ["~ Q W E R T Y U I O P {bksp}", "{tab} A S D F G H J K L Ç ^ ` {enter}", "{shift} Z X C V B N M < > : ? {shift}", "{language} {space} {numbers} {special}"],
    numbers: ['+ 1 2 3 % {bksp}', '- 4 5 6 {space} {language}', '* 7 8 9 = {abc}', '/ . 0 , {enter} {special}'],
    special: ["! @ # $ % ¨ & * ( ) _ + {bksp}", "{tab} { } [ ] \\ | ~ ` {enter}", "{shift} < > , . ; : {shift}", "{language} {space} {numbers} {abc}"]
  },
  [_LanguageEnum.Languages.ES_MX]: {
    default: ["\u00ba q w e r t y u i o p {bksp}", "{tab} a s d f g h j k l \u00f1 \u00b4 ç {enter}", "{shift} z x c v b n m , . - {shift}", "{language} {space} {numbers} {special}"],
    shift: ["\u00aa Q W E R T Y U I O P {bksp}", "{tab} A S D F G H J K L \u00d1 \u00a8 Ç {enter}", "{shift} Z X C V B N M ; : _ {shift}", "{language} {space} {numbers} {special}"],
    numbers: ['+ 1 2 3 % {bksp}', '- 4 5 6 {space} {language}', '* 7 8 9 = {abc}', '/ . 0 , {enter} {special}'],
    special: ["! @ # $ % & / ( ) = ? ¿ \u00a1 {bksp}", "{tab} { } [ ] \\ | ~ ` {enter}", "{shift} < > , . ; : {shift}", "{language} {space} {numbers} {abc}"]
  }
};